import loginModal from '../src/components/modals/login.vue';
import { createApp } from 'vue';
import { plugin, defaultConfig } from '@formkit/vue';

const login = document.querySelector<HTMLElement>('[data-isLoggedIn]');
const loginWrapper = document.querySelector<HTMLElement>('[data-login]');
const productBlockWrapper = document.querySelector<HTMLElement>('[data-product-bundle]');
const memberProductBundle = document.querySelector<HTMLElement>('[data-membership-product-bundle]');
const membershipBlockWrapper = document.querySelector<HTMLElement>('[data-membership-bundle-block]');
const bundleBlockWrapper = document.querySelector<HTMLElement>('[data-membership-discount-block]');
const myInformation = document.querySelector<HTMLElement>('[data-my-information]');
const cartPageWrapper = document.querySelector<HTMLElement>('[data-cart-page]');
const selectGiftPageWrapper = document.querySelector<HTMLElement>('[data-cart-gift-page]');
const cartPersonalInformation = document.querySelector<HTMLElement>('[data-cart-personal-information]');
const selectPaymentMethodPageWrapper = document.querySelector<HTMLElement>('[data-cart-payment-page]');
const resetPasswordPageWrapper = document.querySelector<HTMLElement>('[data-reset-password]');

const isLoggedIn = login ? login.getAttribute('data-isLoggedIn') : null;

if (resetPasswordPageWrapper) {
  import('../src/vue-views/resetPasswordPage.vue').then(({ default: resetPasswordPage }) => {
    const data = typeof resetPasswordPageWrapper.getAttribute('data-reset-password') === 'string' ? JSON.parse(resetPasswordPageWrapper.getAttribute('data-reset-password')) : '';
    resetPasswordPageWrapper.removeAttribute('data-reset-password');
    const appInstance = createApp(resetPasswordPage, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(resetPasswordPageWrapper);
  });
}

if (productBlockWrapper) {
  import('../src/vue-views/productBlock.vue').then(({ default: productBlock }) => {
    const data = typeof productBlockWrapper.getAttribute('data-product-bundle') === 'string' ? JSON.parse(productBlockWrapper.getAttribute('data-product-bundle')) : '';
    productBlockWrapper.removeAttribute('data-product-bundle');
    const appInstance = createApp(productBlock, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(productBlockWrapper);
  });
}

if (memberProductBundle) {
  import('../src/vue-views/membershipBlock.vue').then(({ default: membershipBlock }) => {
    const data = typeof memberProductBundle.getAttribute('data-membership-product-bundle') === 'string' ? JSON.parse(memberProductBundle.getAttribute('data-membership-product-bundle')) : '';
    memberProductBundle.removeAttribute('data-membership-product-bundle');
    const appInstance = createApp(membershipBlock, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(memberProductBundle);
  });
}

if (myInformation) {
  import('../src/vue-views/self-service/myInformationView.vue').then(({ default: myInformationPage }) => {
    const data = typeof myInformation.getAttribute('data-my-information') === 'string' ? JSON.parse(myInformation.getAttribute('data-my-information')) : '';

    myInformation.removeAttribute('data-my-information');
    const appInstance = createApp(myInformationPage, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(myInformation);
  });
}

if (membershipBlockWrapper) {
  import('../src/vue-views/bundleBlock.vue').then(({ default: bundleBlock }) => {
    const data = typeof membershipBlockWrapper.getAttribute('data-membership-bundle-block') === 'string' ? JSON.parse(membershipBlockWrapper.getAttribute('data-membership-bundle-block')) : '';
    membershipBlockWrapper.removeAttribute('data-membership-bundle-block');
    const appInstance = createApp(bundleBlock, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(membershipBlockWrapper);
  });
}

if (bundleBlockWrapper) {
  import('../src/vue-views/bundleBlock.vue').then(({ default: bundleBlock }) => {
    const data = typeof bundleBlockWrapper.getAttribute('data-membership-discount-block') === 'string' ? JSON.parse(bundleBlockWrapper.getAttribute('data-membership-discount-block')) : '';
    bundleBlockWrapper.removeAttribute('data-membership-discount-block');
    const appInstance = createApp(bundleBlock, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(bundleBlockWrapper);
  });
}

if (cartPageWrapper) {
  import('../src/vue-views/cart/cartPageView.vue').then(({ default: cartPage }) => {
    const data = typeof cartPageWrapper.getAttribute('data-cart-page') === 'string' ? JSON.parse(cartPageWrapper.getAttribute('data-cart-page')) : '';
    cartPageWrapper.removeAttribute('data-cart-page');

    const appInstance = createApp(cartPage, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(cartPageWrapper);
  });
}

if (selectGiftPageWrapper) {
  import('../src/vue-views/cart/cartWelcomeGiftView.vue').then(({ default: selectGiftPage }) => {
    const data = typeof selectGiftPageWrapper.getAttribute('data-cart-gift-page') === 'string' ? JSON.parse(selectGiftPageWrapper.getAttribute('data-cart-gift-page')) : '';
    selectGiftPageWrapper.removeAttribute('data-cart-gift-page');
    const appInstance = createApp(selectGiftPage, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(selectGiftPageWrapper);
  });
}

if (cartPersonalInformation) {
  import('../src/vue-views/cart/cartPersonalInformationView.vue').then(({ default: personalInformationPage }) => {
    const data = typeof cartPersonalInformation.getAttribute('data-cart-personal-information') === 'string' ? JSON.parse(cartPersonalInformation.getAttribute('data-cart-personal-information')) : '';
    cartPersonalInformation.removeAttribute('data-cart-personal-information');
    const appInstance = createApp(personalInformationPage, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(cartPersonalInformation);
  });
}

if (selectPaymentMethodPageWrapper) {
  import('../src/vue-views/cart/cartSelectPaymentView.vue').then(({ default: selectPaymentMethodPage }) => {
    const data = typeof selectPaymentMethodPageWrapper.getAttribute('data-cart-payment-page') === 'string' ? JSON.parse(selectPaymentMethodPageWrapper.getAttribute('data-cart-payment-page')) : '';
    selectPaymentMethodPageWrapper.removeAttribute('data-cart-payment-page');
    const appInstance = createApp(selectPaymentMethodPage, { data, isLoggedIn });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(selectPaymentMethodPageWrapper);
  });
}

if (loginModal && loginWrapper) {
  const el = loginWrapper;
  import('../src/components/modals/login.vue').then(({ default: loginModal }) => {
    const dictionary = typeof el.getAttribute('data-dictionary') === 'string' ? JSON.parse(el.getAttribute('data-dictionary')) : '';
    const modal = el.getAttribute('data-modal');
    const isLoggedIn = el.getAttribute('data-isLoggedIn');
    el.removeAttribute('data-dictionary');
    const appInstance = createApp(loginModal, { dictionary, isLoggedIn, modal });
    appInstance.use(plugin, defaultConfig);
    appInstance.mount(el);
  });
}
